var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as queryString from 'query-string';
import { Stack, StackChildren, StackChildrenSize, StackSize, Text, TextColor, TextStyle, } from '@doordash/design-language';
import { CalendarInfoContainerDesktop, CalendarInfoContainerMobile, VerticalSeparator, } from './SharedCalendarStyles';
import { SharedCalendarStrings as strings } from './SharedCalendarStrings';
import { QUERY_PARAMS } from '../../constants/queryParams';
import RedirectTo from '../../core/Common/RedirectTo';
import Header from '../../core/AppLayoutV2/Header';
import InPageContentContainer from '../../core/AppLayoutV2/InPageContentContainer';
import { EXTERNAL_ROUTES, PORTAL_ROUTE_PREFIX } from '../../constants/values';
import { parseSharedCalendarId } from '../../utils/shareCalendarHelper';
import { getCalendarMonthYearTitle } from '../GroupOrders/V2/components/Calendar/CalendarHelper';
import CalendarBiweeklyView from '../GroupOrders/V2/components/Calendar/CalendarBiweeklyView';
import { CalendarViewProvider } from '../GroupOrders/V2/components/Calendar/CalendarViewContext';
import track from '../../utils/track';
import { EmployeeCalendarEvents } from '../../constants/events';
import { useMediaQuery } from '../../core/Common/MediaQueryProvider';
var CalendarInfoContainer = function (_a) {
    var children = _a.children, isMobile = _a.isMobile;
    if (isMobile) {
        return React.createElement(CalendarInfoContainerMobile, null, children);
    }
    return React.createElement(CalendarInfoContainerDesktop, null, children);
};
export var SharedCalendar = function () {
    var _a = __read(React.useState(false), 2), showWeekendsView = _a[0], setShowWeekendsView = _a[1];
    var isMobile = useMediaQuery().isMobile;
    var history = useHistory();
    var searchParams = queryString.parse(useLocation().search);
    var sharedCalendarId = (searchParams === null || searchParams === void 0 ? void 0 : searchParams[QUERY_PARAMS.SHARED_CALENDAR_ID]) || '';
    var calendarInfo = sharedCalendarId
        ? parseSharedCalendarId(sharedCalendarId)
        : null;
    // retrieve month title using the given date range
    var monthDescription = getCalendarMonthYearTitle(14);
    React.useEffect(function () {
        track(EmployeeCalendarEvents.PAGE_VIEW, {
            team_account_id: calendarInfo.teamAccountId,
            office_id: calendarInfo.officeId,
        });
    }, [calendarInfo]);
    if (!calendarInfo) {
        // not cal id or invalid
        return (React.createElement(RedirectTo, { history: history, pathname: PORTAL_ROUTE_PREFIX + "/team-not-found" }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { teamName: calendarInfo.teamName, link: "" + EXTERNAL_ROUTES.MARKETPLACE, isOpenInNewTab: true, isFullPageHeader: true }),
        React.createElement(InPageContentContainer, { isMobile: isMobile },
            React.createElement(Stack, { size: isMobile ? StackSize.XLarge : StackSize.XxLarge },
                React.createElement(StackChildren, { size: StackChildrenSize.XxxSmall },
                    React.createElement(Text, { color: TextColor.TextPrimary, styles: TextStyle.PageTitle2 }, calendarInfo.teamName + "'s " + strings.title()),
                    React.createElement(Text, { color: TextColor.TextSecondary, styles: TextStyle.Body1 }, strings.description()))),
            React.createElement(Stack, { size: StackSize.Medium },
                React.createElement(CalendarInfoContainer, { isMobile: isMobile },
                    React.createElement(Text, { styles: TextStyle.Title1 }, monthDescription),
                    !isMobile && React.createElement(VerticalSeparator, null),
                    React.createElement(Text, { styles: TextStyle.FieldLargeInput }, calendarInfo.officeAddress))),
            React.createElement(CalendarViewProvider, { isEmployeeView: true, calendarInfo: calendarInfo },
                React.createElement(CalendarBiweeklyView, { calendarInfo: calendarInfo, showWeekendsView: showWeekendsView, setShowWeekendsView: setShowWeekendsView })))));
};
export default SharedCalendar;
